import EFPicture from 'elem/compCommon/EFPicture';
import Battery from '@elem/SVGIcon/VanlifeRoadtrips/Battery';
import EnergyConserved from 'elem/SVGIcon/PowerBackup/EnergyConserved';
import SwitchOver from 'elem/SVGIcon/PowerBackup/SwitchOver';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function F() {
    const { useLang } = useGlobal();
    const { t } = useLang('powerindependence');
    const icons: any = [
        {
            icon: <EnergyConserved className="color" />,
            text: t('secF_tag1'),
        },
        {
            icon: <Battery className="color" />,
            text: t('secF_tag2'),
        },
        {
            icon: <SwitchOver className="color fill" />,
            text: t('secF_tag3'),
        },
    ];
    return (
        <div id="power-independence-F" className={`power-independence-F ${css['power-independence-F']}`}>
            <div className="img-box">
                <EFPicture
                    src="/responsive/picture/power-independence/6.jpg"
                    srcMobile="/responsive/picture/power-independence/6_375.jpg"
                    srcPad="/responsive/picture/power-independence/6_375.jpg"
                    alt={t('secF_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secF_title')}</p>
                    <p className="desc">{t('secF_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
